export const setMenu = (data) => ({
    type: 'SET_MENU',
    data
});